import { getAllProjects, UpdateProject , search , deleteProj, addProject} from "@/api/projects";
import { ref } from "vue";



const state = {
    projects: ref({}),
    isLoading: ref(false),
    lists: ref([]),
    developers:ref([])

};
const actions = {
    async fetchProject({commit} , page){
        try{
            const response = await getAllProjects(page);
            commit('SET_PROJECTS' , response.data.projects);
            commit('SET_DEVELOPERSLIST' , response.data.developers);
        }catch(error){
            console.log(error)
        }
    },
    async updateProject({commit} , project){
        try{
            const response = await UpdateProject(project);
            commit('UPDATE_PROJECT' , project)
        }catch(e){
            console.log(e)
        }
    },
    async searchProject({commit} , data){
        try{
            const response = await search( data.value , data.page);
            commit('SET_PROJECTS' , response.data.projects);
        }catch(error){
            console.log(error)
        }
    },
    async deleteProject({commit} , id){
        try{
            await deleteProj(id);
            commit('DELETE_PROJECT' , id);

        }catch(e){
            console.log(e);
        }
    },
    async addNewProject({commit} , project){
        try{
            const resProject = await addProject(project);
            console.log(resProject);
            //commit('ADD_PROJECT' , resProject.data.projects);
        }catch(error){
            console.log(error)
        }
    },
};
const mutations = {
    UPDATE_PROJECT(state , updatedProject){
        
        state.projects.data.map((project, index) => {
            if (project.id === updatedProject.id) {
                state.projects.data[index] = updatedProject;
            }
        });
    },

    DELETE_PROJECT(state , id){
        state.projects.data = state.projects.data.filter(project => project.id !== id);
    },

    SET_PROJECTS(state , projects){
        
        state.projects = projects;
        state.projects.data = state.projects.data.map(project => ({
            ...project,
            is_project_show:false,
            is_edit_active:false,
            is_filter_opens:false,
        }))
        
    },
    SET_DEVELOPERSLIST(state , developers){
        state.developers = developers;
    },

    ADD_PROJECT(state , project){
        state.projects.data.unshift({
            ...project,
            is_project_show:false,
            is_edit_active:false,
            is_filter_opens:false,
        });
    }
};
const getters = {
    getProjects: (state) => state.projects,
    getDevelopersList: (state) => state.developers,
    /* getUnits: (state) => state.units,
    getLists:(state) => state.lists, */
};


export default {
    namespaced: true,
    state , 
    getters,
    mutations,
    actions
};